










import { Component, Vue } from 'vue-property-decorator';

import Container from '@/components/layout/Container.vue';

import TeaserVideo from '@/components/landing/TeaserVideo.vue';

@Component({
  components: { Container, TeaserVideo },
})
export default class DescriptionSection extends Vue {}
